import React from 'react';
import PropTypes from 'prop-types';

const PrettyTagSelector = ({ dataList, onChange, values = [] }) => {
    const styles = {
        prettyTags: {
            display: 'flex',
            flexWrap: 'wrap',
        },
        prettyTag: {
            display: 'inline-block',
            backgroundColor: 'rgba(255, 255, 255, .9)',
            border: '2px solid rgba(139, 139, 139, .3)',
            color: '#adadad',
            borderRadius: '25px',
            whiteSpace: 'nowrap',
            padding: '1rem 2rem',
            margin: '.2rem',
            userSelect: 'none',
            transition: 'all .2s',
            cursor: 'pointer',
            alignItems: 'center',
            display: 'inline-flex',
        },
        prettyTagActive: {
            border: '2px solid #1bdbf8',
            backgroundColor: '#12bbd4',
            color: '#fff',
        },
        icon: {
            transition: 'transform .2s',
            marginRight: '.5rem',
        },
        iconActive: {
            transform: 'rotate(-360deg)',
        },
        '@media (max-width: 600px)': {
            prettyTag: {
                padding: '.3rem 1rem',
            }
        }
    };

    const handleClick = tagName => {
        let newTagList;
        if (values.includes(tagName)) {
            newTagList = values.filter(tag => tag !== tagName);
        } else {
            newTagList = [...values, tagName];
        }
        onChange(newTagList.length > 0 ? newTagList : null);
    }

    return (
        <div style={styles.prettyTags}>
            {dataList.map((data, index) => {
                const isActive = values.includes(data);
                const tagStyle = {
                    ...styles.prettyTag,
                    ...(isActive ? styles.prettyTagActive : {}),
                };
                const iconStyle = {
                    ...styles.icon,
                    ...(isActive ? styles.iconActive : {}),
                };

                return (
                    <div
                        style={tagStyle}
                        key={index}
                        onClick={() => handleClick(data)}
                    >
                        <span style={{ ...iconStyle, marginRight: '.5rem' }}>
                            {isActive ? (
                                // Simple checkmark SVG
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M4 8.5L7 11.5L12 5.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            ) : (
                                // Simple plus SVG
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M8 3V13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                    <path d="M3 8H13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                </svg>
                            )}
                        </span>
                        <span>{data}</span>
                    </div>)
            })}
        </div>
    )
}

PrettyTagSelector.propTypes = {
    onChange: PropTypes.func,
    dataList: PropTypes.array,
    values: PropTypes.array,
}

export default PrettyTagSelector
